import * as Yup from 'yup';

export const healthSignInSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().min(8).required('Please provide a your password'),
});

export type healthSignInDataType = Yup.InferType<typeof healthSignInSchema>;

type InitialValues = {
  email: string;
  password: string;
};

export const healthSigninInitialValues: InitialValues = {
  email: '',
  password: '',
};

interface IAuthCredentials {
  accessToken: string;
  refreshToken: string;
  accessTokenTtl: number;
}

export interface ILicense {
  id: string;
  cacCertificate: string;
  license: string;
  facilityId: string;
  status: string;
  approvedBy: string;
  approvedAt: string;
  createdAt: string;
  updatedAt: string;
}

export interface IHealthData {
  id: string;
  institutionName: string;
  firstName: string;
  lastName: string;
  email: string;
  street: string;
  state?: string | null;
  city?: string | null;
  localGovernment?: string | null;
  serviceIndustry: string;
  bio?: string | null;
  profileImage?: string | null;
  isVerified: boolean;
  isCredentialsApproved: boolean;
  approvedBy: string | null;
  approvedAt: string | null;
  updatedAt: string;
  createdAt: string;
  address: string;
  facilityId: string;
  facilityType: string;
  country: string;
  cacCertificate: string;
  license: ILicense;
  authCredentials: IAuthCredentials;
  tier: string;
}
